import { Html5Qrcode } from "html5-qrcode";
import { ref, nextTick } from "vue";
import { useState } from "./useState";
import { showAlert } from "@erp/shared/utils/dialog";
export const useQr = (options = {}) => {
    const { config = { fps: 10, qrbox: 250 }, onScanSuccess: externalOnScanSuccess, onScanError: externalOnScanError, } = options;
    const html5Qrcode = ref(null);
    const [qrResult, setQrResult] = useState("");
    const [error, setError] = useState(null);
    const [isScanning, setIsScanning] = useState(false);
    const stopScan = async () => {
        if (html5Qrcode.value) {
            try {
                await html5Qrcode.value.stop();
                setIsScanning(false);
            }
            catch (error) {
                console.error("QR 스캐너 정리 중 오류:", error);
            }
        }
    };
    const onScanSuccess = async (decodedText, result) => {
        console.log("QR 스캔 성공:", decodedText, result);
        setQrResult(decodedText);
        // 외부 콜백이 있으면 실행
        if (externalOnScanSuccess) {
            await externalOnScanSuccess(decodedText, result);
        }
        await stopScan();
    };
    const onScanError = (errorMessage) => {
        if (externalOnScanError) {
            externalOnScanError(errorMessage);
        }
    };
    const handleError = (error) => {
        let errorMessage = "알 수 없는 오류가 발생했습니다.";
        if (error instanceof Error) {
            errorMessage = error.message;
            if (error.message.includes("NotAllowedError") ||
                error.message.includes("Permission denied")) {
                errorMessage =
                    "카메라 접근 권한이 거부되었습니다. 브라우저 설정에서 카메라 권한을 허용해주세요.";
            }
            else if (error.message.includes("NotFoundError") ||
                error.message.includes("No camera found")) {
                errorMessage =
                    "카메라를 찾을 수 없습니다. 카메라가 연결되어 있는지 확인해주세요.";
            }
        }
        setError(errorMessage);
        showAlert(errorMessage);
        setIsScanning(false);
    };
    const startScan = async () => {
        try {
            setIsScanning(true);
            // DOM이 렌더링될 때까지 대기
            await nextTick();
            // reader 요소가 존재하는지 확인
            const readerElement = document.getElementById("reader");
            if (!readerElement) {
                throw new Error("QR 스캐너 요소를 찾을 수 없습니다.");
            }
            // Html5Qrcode 인스턴스 생성 (이미 있으면 재사용)
            if (!html5Qrcode.value) {
                html5Qrcode.value = new Html5Qrcode("reader");
            }
            await html5Qrcode.value.start({
                facingMode: "environment",
            }, config, onScanSuccess, onScanError);
        }
        catch (error) {
            handleError(error);
            await stopScan();
        }
    };
    return {
        qrResult,
        error,
        isScanning,
        startScan,
        stopScan,
    };
};
